import { render, staticRenderFns } from "./testImage.vue?vue&type=template&id=084a4498"
import script from "./testImage.vue?vue&type=script&lang=js"
export * from "./testImage.vue?vue&type=script&lang=js"
import style0 from "./testImage.vue?vue&type=style&index=0&id=084a4498&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports